var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modelStyle"},[_c('div',{staticClass:"test"}),_c('charts',{ref:"chart",attrs:{"id":"test1","options":_vm.barOption,"height":"100%"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }